import {planTypes} from "@/common/constants";

export default {
  data () {
    return {
      logo: require('@/assets/plans/logo_workspace_reservation.svg'),
      title: this.$t('billing.workspace_reservation.title'),
      planType: planTypes.WORKSPACE_RESERVATION,
    }
  }
};
